/* eslint-disable */
/**
 * @note This is an auto-generated file. Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:mp` in the terminal
 */

import * as Types from '../../../../../../../types/graphqlTypes'

import { gql } from '@apollo/client'
export type ITonuFragment = { __typename?: 'CarrierTonu' } & Pick<
  Types.ICarrierTonu,
  'id' | 'amount' | 'isOop' | 'oopReason' | 'approvedAt'
> & {
    shipperProofOfTonu?: Types.Maybe<
      { __typename?: 'ShipperProofOfTonu' } & Pick<Types.IShipperProofOfTonu, 'id'> & {
          document?: Types.Maybe<
            { __typename?: 'Downloadable' } & Pick<Types.IDownloadable, 'url' | 'name'>
          >
        }
    >
    carrier: { __typename?: 'CarrierApplication' } & Pick<Types.ICarrierApplication, 'id' | 'name'>
    shipmentAccessorial?: Types.Maybe<
      { __typename?: 'ShipmentAccessorial' } & Pick<
        Types.IShipmentAccessorial,
        | 'id'
        | 'shipperAmount'
        | 'description'
        | 'additionalInfo'
        | 'shipperApprovalState'
        | 'shipperRejectionReason'
        | 'isCustomerRequest'
      >
    >
    shipment: { __typename?: 'Shipment' } & Pick<
      Types.IShipment,
      'id' | 'shipperTotalCarrierTonuRate' | 'carrierTotalCarrierTonuRate'
    >
    rateConfirmation?: Types.Maybe<
      { __typename?: 'CarrierTonuRateConfirmation' } & Pick<
        Types.ICarrierTonuRateConfirmation,
        'id'
      > & { document: { __typename?: 'Downloadable' } & Pick<Types.IDownloadable, 'url' | 'name'> }
    >
  }

export const TonuFragmentDoc = gql`
  fragment Tonu on CarrierTonu {
    id
    amount
    isOop
    oopReason
    approvedAt
    shipperProofOfTonu {
      id
      document {
        url
        name
      }
    }
    carrier {
      id
      name
    }
    shipmentAccessorial {
      id
      shipperAmount
      description
      additionalInfo
      shipperApprovalState
      shipperRejectionReason
      isCustomerRequest
    }
    shipment {
      id
      shipperTotalCarrierTonuRate
      carrierTotalCarrierTonuRate
    }
    rateConfirmation {
      id
      document {
        url
        name
      }
    }
  }
`
